module.exports = __webpack_public_path__ + "static/img/erweima.fecb204.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/erweima.png
// module id = wLs/
// module chunks = 0